import { colord } from 'colord';

const colors = createVariations({
    black: '#000000',
    transparent: 'transparent',
    current: 'currentColor',
    dark: '#333333',
    white: '#ffffff',
    primary: '#ef3e31',
    blue: {
        DEFAULT: '#0194d3',
        600: '#2a60ac',
        700: '#3b3b97',
        800: '#2f2f81',
    },
    red: {
        DEFAULT: '#ef4031',
        600: '#cc2027',
        700: '#bd202f',
    },
    yellow: {
        400: '#ffda00',
    },
    orange: {
        DEFAULT: '#f7a538',
    },
    magenta: {
        600: '#a31d52',
    },
    purple: {
        DEFAULT: '#6c3f99',
    },
    green: {
        300: '#d7df27',
        400: '#c0d84b',
        600: '#62b749',
    },
    gray: {
        200: '#f6f5f8',
        300: '#e9e9e9',
        400: '#9b9b9b',
        DEFAULT: '#919191',
    },
    // BRAND
    tv: '#25408f',
    opinion: '#da2128',
    motor: '#00aeef',
    news: '#da2128',
    buzz: '#ec008c',
    sports: '#ea8024',
    life: '#00954d',
    ebrasil: '#eb1e25',
});

export const theme = {
    colors,
    fontFamily: {
        title: ['Dax', 'sans-serif'],
        sans: ['Roboto', 'sans-serif'],
    },
} as any;

export default theme;

function createVariations(colors: any) {
    const variations: any = {};
    for (const color in colors) {
        if (['transparent', 'current', 'black', 'white'].includes(color)) {
            variations[color] = colors[color];
            continue;
        }
        if (typeof colors[color] === 'object') {
            for (const shade in colors[color]) {
                if (shade.toUpperCase() != 'DEFAULT') variations[`${color}-${shade}`] = colors[color][shade];
                else variations[color] = colors[color][shade];
            }
            continue;
        }

        variations[color] = colors[color];
        const col = colord(colors[color]);
        for (let i = 0.05; i <= 0.2; i += 0.05) {
            variations[`${color}-${Math.abs(Math.round(i * 2000 - 500))}`] = col.lighten(i).toHex();
        }
        for (let i = 0.05; i <= 0.2; i += 0.05) {
            variations[`${color}-${Math.abs(Math.round(i * 2000 + 500))}`] = col.darken(i).toHex();
        }
    }
    return variations;
}

export function vuetifyColors() {
    const vuetifyColors: any = {};
    for (const color in theme.colors) {
        if (['transparent', 'current'].includes(color)) continue;
        vuetifyColors[color] = theme.colors[color];
    }
    return vuetifyColors;
}

export function tailwindColors() {
    const tailwindColors: any = {};
    for (const color in theme.colors) {
        if (['transparent', 'current'].includes(color)) {
            tailwindColors[color] = theme.colors[color];
            continue;
        }
        tailwindColors[color] = `rgba(var(--v-theme-${color}), <alpha-value>)`;
    }

    return tailwindColors;
}
